import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { resolveDocumentTitle } from '../utils/pageTitles';

// Persistent outside guards: sign-in/loading can replace pages at the same URL.
export default function DocumentTitleManager() {
  const { pathname } = useLocation();
  const { isLoading, isAuthenticated } = useAuth();
  const title = resolveDocumentTitle(pathname, { isLoading, isAuthenticated });

  useEffect(() => {
    document.title = title;
  }, [title]);

  return null;
}
